import React from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {Button, Col, ControlLabel, FormControl, FormGroup, Grid, InputGroup, Label, Row} from 'react-bootstrap';
import Tree, {TreeNode} from 'draggable-react-tree-component';
import {Typeahead} from "react-bootstrap-typeahead";
import BUtils from './../../../utilities/BaseUtilities';
import {MorphoPlayground} from "./MorphoPlayground";
import stylesMorphoRule from "../../../_css/dictionary/lexemeParts/lexemeMorphoRule.module.css";
import FontAwesome from "react-fontawesome";
import {LexemeUtilities} from "../../page/editor/LexemeHelper";
import {NodeOperations as TreeHelper, TreeNodeHelper} from "../../../dict-components/tree/components/TreeHelper";


export class MorphoRuleEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            itemData: '',
            originalItemData: '',
            openPlayground: false,
            openTest: false,
            testRule: '',
            testText: '',
            testResult: {},
            transformationRules: [],
            denominations: [],
            selectedTransformationRuleId: '',
            saveAllowed: {value: true, message: ''},
            page: 1,
            savingStatus: 'default',
            validationStatus: 'default'
        };

        this.isNew = typeof this.props.item === 'undefined' || this.props.item === null;
        this.key = this.isNew ? 'new' : this.props.item.key;
        this.pageDescription = [this.isNew ? 'NEW_RULE' : 'EDIT', 'GRAMMATICAL_CATEGORIES', 'MARKERS'];
    }

    componentWillMount() {
        this._retrieveRule(this.key);
    }

    componentDidMount() {
        /*if (this.isNew)
            ReactDOM.findDOMNode(this.morphoRuleDescription).focus();*/
    }

    _retrieveAndSetSiblingNames(siblings) {
        const siblingNames = siblings.filter((item) => {
            return this.isNew || item.key !== this.props.item.key;
        }).map((item) => {
            return item.title;
        });

        this.setState({siblingNames});
    }

    _retrieveRule(key) {
        if (this.isNew) {
            const itemData = {uniqueDescription: '', pathToObject: []};
            var retrieveItemData = new Promise((resolve) => {
                if (this.props.parent !== null) {
                    return resolve(Dict.call('/declinedForms/getMorphoRulePathToObject/' + this.props.parent.key + '/'));
                } else {
                    return resolve([]);
                }
            });
            retrieveItemData.then((pathToObject) => {
                if (pathToObject.length > 0) {
                    pathToObject.push({
                        id: this.props.parent.key,
                        uniqueDescription: this.props.parent.title
                    });
                    itemData.pathToObject = pathToObject;
                }
                this.setState({itemData, originalItemData: BUtils.cloneJson(itemData)}, () => {
                    ReactDOM.findDOMNode(this.morphoRuleDescription).focus();
                });
            });

        } else {
            Dict.call('/declinedForms/getMorphoRule/' + key + '/').then((itemData) => {
                this.setState({itemData, originalItemData: BUtils.cloneJson(itemData)});
            });

            Dict.call('/declinedForms/getDenominations/' + key + '/').then((denominations) => {
                this.setState({
                    denominations
                });
            });
        }

        var siblingNames = null;
        if (typeof this.props.item === 'undefined' || typeof this.props.item.parentKey === 'undefined') {
            siblingNames = this._retrieveAndSetSiblingNames(this.props.treeStructure);
        } else {
            TreeHelper.traverseToKey(this.props.treeStructure, this.props.item.parentKey, (parentItem) => {
                siblingNames = this._retrieveAndSetSiblingNames(parentItem.children);
            });
        }
    }

    _openPlayground() {
        const container = document.getElementById('morpho-playground-container');
        const openPlayground = !this.state.openPlayground;
        if (!openPlayground) {
            ReactDOM.unmountComponentAtNode(container);
            this.setState({openPlayground});
        } else {
            ReactDOM.render(<MorphoPlayground
                callbackParent={(method) => this._handleChooseMethod(method, false, false)}/>, container, () => {
                this.setState({openPlayground});
            });
        }
    }

    _changePageEvents(page) {
        var saveAllowed = {};
        if (page === 1 || page === 2) {
            saveAllowed.value = true;
            saveAllowed.message = '';
            if (this.state.openPlayground) {
                this._openPlayground()
            }
        } else if (page === 3) {
            const hasActions = this.state.denominations.find((item) => {
                return item.action === 'toAdd' || item.action === 'toRemove';
            });
            saveAllowed.value = typeof hasActions !== 'undefined';
            saveAllowed.message = '';
        }

        this.setState({saveAllowed});

    }

    _handleChooseMethod(method, forceContext, forceReplace) {
        const toTestRule = this.state.openTest && !forceContext;
        var value = '';
        var transformationRules = this.state.transformationRules;
        var tr = null;
        if (this.state.page === 1) {
            value = toTestRule ? this.state.testRule : this.state.itemData.phoneticContext;
        } else {
            tr = transformationRules.find((item) => {
                return item.id === this.state.selectedTransformationRuleId;
            });

            value = tr.value === null ? '' : tr.value;
        }

        if (typeof value === 'undefined' || value.trim() === '' || forceReplace /*value.trim() === 'BSH:true' || method === 'BSH:true'*/) {
            value = method;
        } else {
            value += " || " + method;
        }

        if (this.state.page === 1) {
            if (toTestRule) {
                this.setState({testRule: value});
            } else {
                var itemData = this.state.itemData;
                itemData.phoneticContext = value;
                this.setState({itemData});
            }
        } else {
            tr.oldValue = typeof tr.value === 'undefined' || tr.value === null ? '' : tr.value;
            tr.value = value;
            this.setState({transformationRules});
        }
    }

    _handleOpenCloseTest() {
        const openTest = !this.state.openTest;
        this.setState({openTest});
    }

    _resetTestResult() {
        var testResult = {};
        this.setState({testResult});
    }

    _saveRule() {
        var itemData = {};
        var morphoClass = [];
        var parentId = null;
        if (this.isNew) {
            itemData = this.state.itemData;
            parentId = this.props.parent !== null ? this.props.parent.key : null;
        } else {
            itemData = {
                id: this.state.itemData.id,
                phoneticContext: this.state.itemData.phoneticContext,
                uniqueDescription: this.state.itemData.uniqueDescription
            };
            morphoClass = this.state.itemData.morphoClass;
        }


        this.setState({savingStatus: 'warning'});
        Dict.call('/declinedForms/saveRule/' + this.isNew + '/' + LexemeUtilities.encodeUrl(JSON.stringify(itemData)) + '/' + LexemeUtilities.encodeUrl(JSON.stringify(morphoClass)) + '/' + this.props.languageId + '/' + parentId + '/').then((result) => {
            if (result.result === 'OK') {
                const originalItemData = itemData;
                this.setState({originalItemData, savingStatus: 'success'});
                if (this.isNew) {
                    var obj = {
                        key: result.id,
                        title: result.uniqueDescription,
                        isLeaf: true,
                        children: []
                    };
                    this.props.callbackParentReloadTree(obj);
                } else {
                    this.props.callbackParentReloadTree();
                    setTimeout(function () {
                        this.setState({savingStatus: 'default'});
                    }.bind(this), 2000);
                }
            }
        });
    }

    _retrieveModifiedOrEmptyRules() {
        return this.state.transformationRules.filter((rule) => {
            return typeof rule.oldValue !== 'undefined' || (rule.value !== null && rule.value.trim() === '');
        });
    }

    _resetRule(rule) {
        var transformationRules = this.state.transformationRules;
        var indexRule = transformationRules.findIndex((tr) => {
            return tr.id === rule.id;
        });
        transformationRules[indexRule] = rule;

        return transformationRules;
    }

    _resetTransformationRules(page) {
        Dict.call('/declinedForms/getMorphoRuleTransformations/' + this.props.item.key + '/').then((itemData) => {
            const transformationRules = itemData.transformationRules;
            var saveAllowed = page === 3 ? this._checkDenominationsSaveAllowed() : this.state.saveAllowed;
            this.setState({page, transformationRules, saveAllowed}, () => {
                if (this.state.openPlayground) {
                    this._openPlayground()
                }
            });
        });
    }

    _saveTransformationRules() {
        this.setState({savingStatus: 'warning'});
        var modifiedRules = this._retrieveModifiedOrEmptyRules();
        Dict.call('/declinedForms/saveTransformationRules/' + this.props.item.key + '/', {
            method: 'POST',
            data: modifiedRules,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((result) => {
            this._resetRules(result);
        });
    }

    _validateTransformationRules() {
        this.setState({validationStatus: 'warning'}, () => {
            const transformationRules = this.state.transformationRules;
            Dict.call('/declinedForms/validateMorphoRuleTransformationsByCollection/' + this.props.item.key + '/', {
                method: 'POST',
                data: transformationRules,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then((newTransformationRules) => {
                this.setState({
                    transformationRules: newTransformationRules,
                    savingStatus: 'default',
                    validationStatus: 'default'
                });
            });

        })
    }

    _resetRules(modifiedRulesToReset) {
        var transformationRules = this.state.transformationRules;

        transformationRules.forEach((rule, index) => {
            var indexModifiedRule = modifiedRulesToReset.findIndex((tr) => {
                return tr.id === rule.id;
            });

            if (indexModifiedRule >= 0)
                transformationRules[index] = modifiedRulesToReset[indexModifiedRule];
        });

        this.setState({transformationRules, savingStatus: 'success', validationStatus: 'default'}, () => {
            setTimeout(function () {
                this.setState({savingStatus: 'default'});
            }.bind(this), 2000);
        });
    }

    _saveMarkers() {
        this.setState({savingStatus: 'warning'}, () => {
            var markers = this.state.denominations.filter((item) => {
                return item.action;
            });
            Dict.call('/declinedForms/saveMarkers/' + this.props.item.key + '/', {
                method: 'POST',
                data: markers,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then((denominations) => {
                this.setState({
                    savingStatus: 'success',
                }, () => {
                    this.setState({denominations}, () => {
                        this._resetTransformationRules(3);
                        setTimeout(function () {
                            this.setState({savingStatus: 'default'});
                        }.bind(this), 2000);
                    });
                });
            });
        })
    }

    _checkDenominationsSaveAllowed() {
        var saveAllowed = this.state.saveAllowed;
        var foundDenominationsToAdd = this.state.denominations.find((item) => {
            return item.action;
        });

        if (foundDenominationsToAdd) {
            saveAllowed.value = true;
            saveAllowed.message = Dict.t('ALERT_TRANSFORMATION_RULES_RESET');
        } else {
            saveAllowed.value = false;
            saveAllowed.message = '';
        }

        return saveAllowed;
    }

    render() {

        const itemData = this.state.itemData;
        const page = this.state.page;
        const foundItemData = typeof itemData !== 'undefined' && itemData !== '';

        var selected = [];

        if (!this.isNew && foundItemData) {
            selected = itemData.morphoClass === null || itemData.morphoClass.length === 0 ? [] : itemData.morphoClass;
        }

        var playGround = <div id={'morpho-playground-container'}
                              className={BUtils.joinClasses(stylesMorphoRule['morpho-playground-container'], stylesMorphoRule['morpho-playground-container--' + this.state.openPlayground])}/>;

        var contents = null;
        var buttons = null;

        var saveFunction = null;
        var saveName = 'SAVE';

        const pathToObject = foundItemData && this.state.itemData.pathToObject.length > 0 ? this.state.itemData.pathToObject.map((item) => {
            return <>
                <span className={stylesMorphoRule['morpho-rule-path-to-object__descr']} onClick={() => {
                    var parent = {
                        key: item.id,
                        title: item.uniqueDescription,
                        isLeaf: false,
                        children: []
                    };

                    this.props.callbackParentOpen(parent);
                }
                }>{item.uniqueDescription}</span>
                <span className={stylesMorphoRule['morpho-rule-path-to-object__sep']}>/</span>
            </>
        }) : '';


        const label = foundItemData ?
            <h3 className={stylesMorphoRule['morpho-rule-edit__label']}>
                {pathToObject}<Label style={{
                verticalAlign: '9%',
                marginLeft: '10px'
            }}>{this.state.originalItemData.uniqueDescription}</Label><span
                className={stylesMorphoRule['morpho-rule-edit__label__page']}>{Dict.t(this.pageDescription[this.state.page - 1])}</span>
                <span
                    style={{color: 'red', fontSize: '12px', marginLeft: '10px'}}>{this.state.saveAllowed.message}</span>
            </h3> : '';

        if (page === 1) {
            saveFunction = () => this._saveRule();
            saveName = "SAVE";
            contents = typeof itemData !== 'undefined' && itemData !== '' ?
                <>
                    <InputGroup
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-edit-unique-description--' + (this.state.saveAllowed.value)])}>
                        <InputGroup.Addon>{Dict.t('UNIQUE_DESCRIPTION')}</InputGroup.Addon>
                        <FormControl type="text" placeholder={Dict.t('ENTRY') + "..."}
                                     ref={(input) => {
                                         this.morphoRuleDescription = input;
                                     }}
                                     value={itemData.uniqueDescription}
                                     onChange={(evt) => {
                                         var itemData = this.state.itemData;
                                         itemData.uniqueDescription = evt.target.value;
                                         var saveAllowed = {};
                                         saveAllowed.value = true;
                                         saveAllowed.message = '';
                                         if (this.state.siblingNames.indexOf(itemData.uniqueDescription) >= 0) {
                                             saveAllowed.value = false;
                                             saveAllowed.message = Dict.t('RULE_SIBLING_EXISTS');
                                         } else if (itemData.uniqueDescription.trim() === '') {
                                             saveAllowed.value = false;
                                             saveAllowed.message = '';
                                         }

                                         this.setState({itemData, saveAllowed});
                                     }}
                                     onKeyUp={(evt) => {
                                         if (this.isNew && evt.keyCode === 13) {
                                             this._saveRule();
                                         }

                                     }}/>
                    </InputGroup>
                    {this.isNew ? '' : <>
                        <InputGroup className={stylesMorphoRule['morpho-rules-edit-morpho-class-typeahead-group']}>
                            <InputGroup.Addon key={"key-ref-create-entry"}
                                              style={{
                                                  fontWeight: 'bold',
                                                  minWidth: '80px',
                                                  fontSize: '12px',
                                                  height: '10px'
                                              }}>{Dict.t('MORPHO_CLASS')}</InputGroup.Addon>
                            <Typeahead
                                id={'morpho-class-combo'}
                                className={stylesMorphoRule['morpho-class-combo']}
                                key={'key-morpho-class-combo'}
                                clearButton={true}
                                autoFocus={false /*true*/}
                                ref={"revisionStatusTypeahead"}
                                align={"justify"}
                                onChange={item => {
                                    var itemData = this.state.itemData;
                                    itemData.morphoClass = item;

                                    this.setState({itemData});
                                }}
                                options={itemData.morphoComboClasses}
                                selected={selected}
                                placeholder={Dict.t('NO_CHOICE')}
                            />
                        </InputGroup>
                        <FormGroup>
                            <ControlLabel>{Dict.t('PHONETIC_CONTEXT')}</ControlLabel>
                            <FormControl componentClass="textarea" placeholder="" value={itemData.phoneticContext}
                                         onChange={(evt) => {
                                             var itemData = this.state.itemData;
                                             itemData.phoneticContext = evt.target.value;
                                             this.setState({itemData});
                                         }}
                                         onKeyUp={(evt) => {
                                         }}/>
                        </FormGroup>
                        <div
                            className={BUtils.joinClasses(stylesMorphoRule['morpho-rule__test-container'], stylesMorphoRule['morpho-rule__test-container--' + this.state.openTest])}>
                            <h4 style={{marginTop: '0', marginBottom: '12px', marginLeft: '3px'}}><Label>Test
                                Environment</Label></h4>
                            <InputGroup>
                                <InputGroup.Addon>{'Test text'}</InputGroup.Addon>
                                <FormControl type="text" placeholder={Dict.t('ENTRY') + "..."}
                                             value={this.state.testText}
                                             onChange={(evt) => {
                                                 const testText = evt.target.value;
                                                 this._resetTestResult();
                                                 this.setState({testText});
                                             }}
                                             onKeyUp={(evt) => {
                                             }}/>
                            </InputGroup>
                            <FormGroup style={{marginTop: '10px', marginBottom: '15px'}}>
                                <ControlLabel style={{marginBottom: '0px'}}>{'Rule'}</ControlLabel>
                                <FormControl componentClass="textarea" placeholder="" value={this.state.testRule}
                                             onChange={(evt) => {
                                                 const testRule = evt.target.value;
                                                 this.setState({testRule});
                                                 this._resetTestResult();
                                             }}
                                             onKeyUp={(evt) => {
                                             }}/>
                            </FormGroup>
                            <Button onClick={() => {
                                this._handleChooseMethod(this.state.testRule, true, false)
                            }}>update and close</Button>
                            <Button onClick={() => {
                                this._handleChooseMethod(this.state.testRule, true, true)
                            }}>replace and close</Button>
                            <Button onClick={() => {
                                Dict.call('/declinedForms/testMorphoRule/' + this.props.languageId + '/' + this.state.testText + '/' + this.state.testRule + '/null/').then((result) => {
                                    var testResult = {};
                                    if (result.error !== '') {
                                        testResult.error = true;
                                    } else {
                                        testResult.error = false;
                                        testResult.value = result.value;
                                    }

                                    this.setState({testResult});
                                })
                            }
                            }>test</Button>
                            <div
                                className={stylesMorphoRule['morpho-rule__test-result-container']}>{Object.keys(this.state.testResult).length === 0 ? '' : 'result: ' + this.state.testText + ' >>>>> ' + this.state.testResult.value} </div>
                        </div>
                    </>}
                </> : '';

            buttons = this.isNew ? '' : <>
                <Button onClick={() => this._openPlayground()}>{Dict.t('OPEN_PLAYGROUND')}</Button>
                <Button
                    onClick={() => this._handleOpenCloseTest()}>{Dict.t('OPEN_CLOSE_MORPHO_RULE_TEST')}</Button>
                <Button
                    onClick={() => this._handleChooseMethod('BSH:true', true, true)}>{Dict.t('SET_BSH_TRUE')}</Button>
                <Button
                    onClick={() => this._handleChooseMethod(this.state.originalItemData.phoneticContext, true, true)}>{Dict.t('RESET_PHONETIC_CONTEXT')}</Button>
                <Button onClick={() => {
                    this._resetTransformationRules(2);
                }}><FontAwesome name={"forward"}/></Button>
            </>

        } else if (page === 2) {
            saveFunction = () => this._saveTransformationRules();
            saveName = "SAVE_TRANSFORMATION_RULES";
            contents = this.state.transformationRules.map((item, index) => {
                const isSelected = this.state.selectedTransformationRuleId === item.id;
                const hasOldValue = typeof item.oldValue !== 'undefined' && item.oldValue !== null;

                const resetButton = hasOldValue && typeof item.value !== 'undefined' && item.value.replace("\r", "") !== item.oldValue.replace("\r", "") ?
                    <Button className={stylesMorphoRule['morpho-transformation-rule-reset-button']}
                            onClick={() => {
                                var transformationRules = this.state.transformationRules;
                                var trRule = transformationRules[index];
                                trRule.value = trRule.oldValue.replace("\r", "");
                                this.setState({transformationRules});
                            }
                            }
                    >reset</Button> : '';

                const copyBelow = index < (this.state.transformationRules.length - 1) && isSelected && typeof item.value !== 'undefined' && item.value !== null && item.value.trim() !== '' ?
                    <Button className={stylesMorphoRule['morpho-transformation-rule-reset-button']}
                            onClick={() => {
                                var transformationRules = this.state.transformationRules;
                                var trRule = transformationRules[index + 1];
                                trRule.oldValue = trRule.value;
                                trRule.value = item.value;
                                this.setState({transformationRules});
                            }
                            }
                    >copia sotto</Button> : '';

                return <Row
                    className={BUtils.joinClasses(stylesMorphoRule['morpho-transformation-rules__row'], stylesMorphoRule['morpho-transformation-rules__row--' + isSelected])}
                    onClick={() => {
                        this.setState({selectedTransformationRuleId: item.id})
                    }}>
                    <Col lg={4} md={4}
                         className={BUtils.joinClasses(stylesMorphoRule['morpho-transformation-rules__row__label'])}>{item.label}{resetButton}{copyBelow}</Col>
                    <Col lg={8} md={8} className={stylesMorphoRule['morpho-transformation-rules__row__value']}>
                        <FormControl componentClass="textarea" placeholder={""}
                                     value={item.value}
                                     className={stylesMorphoRule['morpho-transformation-rules__validation--' + (typeof item.isValid === 'undefined' || item.isValid)]}
                                     onChange={(evt) => {
                                         var transformationRules = this.state.transformationRules;
                                         var trRule = transformationRules[index];
                                         if (typeof trRule.oldValue === 'undefined') {
                                             trRule.oldValue = trRule.value !== null ? trRule.value : '';
                                         }

                                         trRule.value = evt.target.value;
                                         this.setState({transformationRules});
                                     }}
                                     onKeyUp={(evt) => {
                                     }}/>
                    </Col>
                </Row>;
            });

            buttons = <>
                <Button onClick={() => {
                    this._resetTransformationRules();
                }}>reset</Button>
                <Button className={stylesMorphoRule['morpho-transformation-rules-playground__button']}
                        onClick={() => {
                            var selectedTransformationRuleId = this.state.selectedTransformationRuleId;
                            if (selectedTransformationRuleId === '')
                                selectedTransformationRuleId = this.state.transformationRules[0].id;
                            this.setState({selectedTransformationRuleId});
                            this._openPlayground();
                        }}
                >{Dict.t('OPEN_PLAYGROUND')}</Button>
                <Button bsStyle={this.state.validationStatus} onClick={() => {
                    this._validateTransformationRules();
                }}>check errori</Button>
                <Button onClick={() => {
                    this.setState({page: 1}, () => {
                        this._changePageEvents(1);
                    });
                }}><FontAwesome name={"backward"}/></Button>
                <Button onClick={() => {
                    this.setState({
                        page: 3,
                    }, () => {
                        this._changePageEvents(3);
                    });

                }}><FontAwesome name={"forward"}/></Button>
            </>
        } else if (page === 3) {

            saveFunction = () => this._saveMarkers();
            saveName = "SAVE_MARKERS";

            var markers = this.props.languageToMarker.map((item) => {
                var length = (item.id.split('^').length - 1) * 10;
                var objDen = this.state.denominations.find((denItem) => {
                    return item.description === denItem.description
                });

                return <div id={'langToMarker_' + item.id}
                            className={BUtils.joinClasses(stylesMorphoRule['langToMarker'], stylesMorphoRule['langToMarker--' + (typeof objDen === 'undefined' || objDen.action === 'toRemove' ? 'not-selected' : 'selected')])}
                            style={{
                                marginLeft: length + 'px'
                            }}
                            onClick={() => {
                                var denominations = this.state.denominations;
                                if (typeof objDen === 'undefined')
                                    denominations.push({id: item.id, description: item.description, action: 'toAdd'});
                                else if (objDen.action === 'toAdd') {
                                    var indexDen = denominations.findIndex((denItem) => {
                                        return denItem.description === item.description;
                                    });
                                    denominations.splice(indexDen, 1);
                                } else {
                                    var indexDen = denominations.findIndex((denItem) => {
                                        return denItem.description === item.description;
                                    });

                                    var storedObj = {};
                                    storedObj.id = item.id;
                                    storedObj.description = item.description;
                                    if (objDen.action === 'toRemove')
                                        delete storedObj.action;
                                    else
                                        storedObj.action = 'toRemove';

                                    denominations.splice(indexDen, 1);
                                    denominations.splice(indexDen, 0, storedObj);
                                }

                                var saveAllowed = this._checkDenominationsSaveAllowed();
                                this.setState({denominations, saveAllowed});
                            }}
                >{item.description}</div>;
            });

            contents = <>
                <Grid key={'key-morphorule-edit-language-to-marker-' + this.props.item.key}
                      className={stylesMorphoRule['grid-morpho-language-to-marker']}>{markers}</Grid>
                <div className={stylesMorphoRule['morpho-denominations']}>{this.state.denominations.map((item) => {
                    return <span
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-denomination-item'], stylesMorphoRule['morpho-denomination-item--' + (typeof item.action !== 'undefined' ? item.action : 'stored')])}
                        onClick={() => {
                            document.getElementById('langToMarker_' + item.id).scrollIntoView({behavior: "smooth"});
                        }
                        }>{item.description}</span>
                })}</div>
            </>;

            buttons = <>
                <Button onClick={() => {
                    var denominations = this.state.denominations.filter((item) => {
                        return typeof item.action === 'undefined' || item.action === 'toRemove';
                    }).map((denomination) => {
                        delete denomination.action;
                        return denomination;
                    });

                    var saveAllowed = this.state.saveAllowed;
                    saveAllowed.value = false;
                    saveAllowed.message = '';

                    this.setState({denominations, saveAllowed});
                }}>reset</Button>
                <Button onClick={() => {
                    this.setState({page: 2}, () => {
                        this._changePageEvents(2);
                    });
                }}><FontAwesome name={"backward"}/></Button>
                <Button onClick={() => {
                    this.setState({page: 1}, () => {
                        this._changePageEvents(1);
                    });
                }}><FontAwesome name={"fast-backward"}/></Button>
            </>;
        }

        contents = <Grid key={'key-morphorule-edit-' + (this.isNew ? 'new' : this.props.item.key)}
                         className={stylesMorphoRule['morpho-rule-edit__contents']}>{contents}</Grid>;
        buttons = typeof itemData !== 'undefined' && itemData !== '' ?
            <div
                className={BUtils.joinClasses(stylesMorphoRule['morpho-transformation-rules__buttons'])}>
                <Button bsStyle={this.state.savingStatus} onClick={() => {
                    saveFunction();
                }
                }
                        disabled={!this.state.saveAllowed.value || (this.isNew && itemData.uniqueDescription === '')}>{Dict.t(saveName)}</Button>{buttons}
            </div> : '';

        return <>{playGround}
            <div
                className={stylesMorphoRule['morpho-rule-edit__container']}>{label}{contents}{buttons}</div>
        </>
    }
}